import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./VideoDetail.scss";
import {
    fetchContentNotConvert
} from '../services/apiContent';

import { BASE_URL } from "../services/constant";

const VideoDetail = () => {
  const { id } = useParams();
  const [video, setVideo] = useState(null);
  const [loading, setLoading] = useState(true);

  const [progress, setProgress] = useState({
    v0: 0,
    v1: 0,
    v2: 0,
  });

  const [status, setStatus] = useState({
    v0: false,
    v1: false,
    v2: false,
  });

  const [converting, setConverting] = useState({
  v0: false,
  v1: false,
  v2: false,
});


  // Convertir en HH:MM:SS
  const formatDuration = (seconds) => {
    if (!seconds) return "00:00";
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = Math.floor(seconds % 60);
    return h > 0
      ? `${String(h).padStart(2, "0")}:${String(m).padStart(
          2,
          "0"
        )}:${String(s).padStart(2, "0")}`
      : `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  };

  // Format date
  const formatDate = (d) => {
    return new Date(d).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  // Charger la vidéo
  useEffect(() => {
    async function load() {
      try {
        const data = await fetchContentNotConvert(id);
        //const data = await res.json();
        console.log(data);

        setVideo(data);
        setStatus({
          v0: data.v0 ,
          v1: data.v1,
          v2: data.v2,
        });

        setLoading(false);
      } catch (err) {
        console.error(err);
      }
    }
    load();
  }, [id]);

  // Lance la conversion
  const handleConvert = async (version) => {
    // Progression démarre à 0
    setProgress((p) => ({ ...p, [version]: 0 }));
    setStatus((s) => ({ ...s, [version]: false }));
    setConverting((c) => ({ ...c, [version]: true }));

    // 2️⃣ Ouvrir le flux SSE pour suivre PROGRESS FFmpeg en temps réel
    const evt = new EventSource(
      `${BASE_URL}api/transcode-progress/${id}/${version}`
    );
  
    evt.onmessage = (e) => {
      const data = JSON.parse(e.data);
  
      // 🔥 Mettre à jour la progression réelle
      setProgress((prev) => ({ ...prev, [version]: data.progress }));
  
      // ✔ Conversion terminée
      if (data.status === "done") {
        setStatus((prev) => ({ ...prev, [version]: true }));
        setConverting((prev) => ({ ...prev, [version]: false }));
        evt.close();
      }
  
      // ❌ En cas d’erreur
      if (data.status === "error") {
        alert("Erreur lors de la conversion !");
        setConverting((prev) => ({ ...prev, [version]: false }));
        evt.close();
      }
    };
  
    // 1️⃣ Lancer la conversion côté serveur
    await fetch(`${BASE_URL}api/transcode/${id}/${version}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        relativeSource: video.video_path,
        duration: video.duration, // 👈 chemin vidéo envoyé au backend
      }),
    });
  
  };
    /* -------------------------------------------
     🔥 AJOUT DU BOUTON "Publier en HLS"
  --------------------------------------------- */

  const allConverted = status.v0 && status.v1 && status.v2;
  const anyConverting = Object.values(converting).some(Boolean);


  const publishHLS = async () => {
    const res = await fetch(`${BASE_URL}api/transcode/master/master/${id}`, {
      method: "POST",
    });

    const data = await res.json();

    if (data.success) {
      alert("Publication HLS réussie !");
    } else {
      alert("Erreur lors de la publication HLS");
    }
  };

  const versionLabels = {
    v0: "v0 : 240p - 400kbps",
    v1: "v1 : 480p - 1200kbps",
    v2: "v2 : 720p - 2500kbps",
  };

  if (loading || !video) return <div className="loader">Loading...</div>;

  return (
    
    <div className="page-content">
        <div className="video-detail">
        <h2>Video details</h2>

        {/* Informations générales */}
        
        <div className="video-info">
            <div className="video-info-box">
                <img src={`${BASE_URL}api/${video.image}`} alt="" className="poster" />

                <div className="info">
                    <h1>{video.title}</h1>

                    <ul>
                        <li><b>ID:</b> {video.id}</li>
                        <li><b>Type:</b> {video.type}</li>
                        <li><b>Duration:</b> {formatDuration(video.duration)}</li>
                        <li><b>Date:</b> {formatDate(video.created_at)}</li>
                        <li><b>Category:</b> Film</li>
                        <li><b>Description :</b>  </li>
                        <li><p>{video.description}</p></li>
                    </ul>
                </div>
            </div>
            

        </div>
        <div>

        </div>

        {/* Section Conversion */}
        <h3 className="section-title">Video conversion</h3>

        <table className="convert-table">
            <thead>
            <tr>
                <th>Version</th>
                <th>Status</th>
                <th>Progress</th>
                <th>Action</th>
            </tr>
            </thead>

            <tbody>
            {["v0", "v1", "v2"].map((v) => (
                <tr key={v}>
                <td>{versionLabels[v]}</td>

                <td>
                    {status[v] ? (
                    <span className="ok">✔ Converted</span>
                    ) : (
                    <span className="no">✖ Not converted</span>
                    )}
                </td>

                <td>
                    <div className="progress-bar">
                        <div
                        className="progress"
                        style={{ width: `${progress[v]}%` }}
                        ></div>
                        {progress[v]}%
                    </div>
                </td>

                <td>
                  <button
                    disabled={status[v] || converting[v]  || anyConverting}
                    className={`btn-convert ${converting[v] ? "disabled" : ""}`}
                    onClick={() => handleConvert(v)}
                  >
                    {converting[v] ? <span className="loader-btn"> ... </span> : "Convert"}
                  </button>

                </td>
                </tr>
            ))}
            </tbody>
        </table>

        {/* ----------------------------------------
            🔥 BUTTON PUBLISH HLS (NEW)
        ---------------------------------------- */}
        <div style={{ marginTop: "50px", textAlign: "center" }}>
          <button
            className="btn-publish"
            disabled={!allConverted}
            onClick={publishHLS}
            style={{
              padding: "10px 20px",
              background: allConverted ? "#2ecc71" : "#7f8c8d",
              border: "none",
              color: "#fff",
              cursor: allConverted ? "pointer" : "not-allowed",
              borderRadius: "5px",
              fontSize: "15px",
            }}
          >
            Publier en HLS
          </button>
        </div>


        </div>

    </div>
  );
};

export default VideoDetail;
